import { render, staticRenderFns } from "./ModalInsufficientComponent.vue?vue&type=template&id=264d44be&"
import script from "./ModalInsufficientComponent.vue?vue&type=script&lang=js&"
export * from "./ModalInsufficientComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports